import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
      </div>
    );
  }

  if (!user) {
    // Redirect to the login screen that matches THIS route's audience.
    // The dashboard's `handleLogout` also navigates, but the auth-state
    // change re-renders `ProtectedRoute` first — so this fallback has
    // to pick the right login page on its own, or we end up on the
    // member-login page after an employer logout.
    if (allowedRoles && allowedRoles.includes('admin')) {
      return <Navigate to="/admin-login" replace />;
    }
    if (allowedRoles && (allowedRoles.includes('clinic_admin') || allowedRoles.includes('clinic'))) {
      return <Navigate to="/staff-login" replace />;
    }
    if (allowedRoles && (allowedRoles.includes('employer') || allowedRoles.includes('employer_admin'))) {
      return <Navigate to="/employer-login" replace />;
    }
    // patient / member / anything else → member-login
    return <Navigate to="/member-login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;